<template>
<loader v-bind="{ loading }">
  <div class="box">
    <level :title="Naming.Sites">
      <div  slot="right" class="is-flex is-align-items-center">
        <div class="tabs is-toggle is-toggle-rounded is-raised is-rounded is-marginless" style="overflow:initial">
          <ul>
            <li :class="{ 'is-active pointer-events-none': filters.activeStatus === ''}">
              <a @click="filterBy('activeStatus')">Show All</a>
            </li>
            <li :class="{ 'is-active pointer-events-none': filters.activeStatus === 'active'}">
              <a @click="filterBy('activeStatus', 'active')">Active {{ Naming.Sites }}</a>
            </li>
            <li :class="{ 'is-active pointer-events-none': filters.activeStatus === 'deactivated'}">
              <a @click="filterBy('activeStatus', 'deactivated')">Deactivated {{ Naming.Sites }}</a>
            </li>
          </ul>
        </div>
        <router-link :to="{ name: 'site-admin-create', query: { client: $route.params.client }}" class="button ml-2 is-info is-rounded">
          <icon icon="plus"/>
          <span>New {{ Naming.Site }}</span>
        </router-link>
      </div>
    </level>

    <div class="is-flex is-align-items-center w-full">
      <div class="flex-grow mr-2">
        <text-input
            classes="is-rounded"
            v-model="filters.search"
            @input="filterBy('search', ...arguments)"
            :placeholder="`Search ${Naming.Sites.toLowerCase()}…`">
          <div slot="right">
            <action-button @click="searchSites" left-icon="search" class="is-rounded">Search</action-button>
          </div>
        </text-input>
      </div>
      <div v-if="filters.activeStatus === 'deactivated' && $root.hasAbility('delete-sites', 'Billow\\Models\\Site')">
        <action-button @click="setAllSites('activate')" class="is-rounded mr-1 is-success" :disabled="sites.data.length === 0" left-icon="play">Activate All</action-button>
        <action-button @click="setSelectedSites('activate')" class="is-rounded is-success" :disabled="sites.data.length === 0" left-icon="play">Activate Selected {{ Naming.Sites }}</action-button>
      </div>
      <div v-if="filters.activeStatus === 'active' && $root.hasAbility('delete-sites', 'Billow\\Models\\Site')">
        <action-button @click="setAllSites('deactivate')" class="is-rounded mr-1 is-danger" :disabled="sites.data.length === 0" left-icon="stop">Deactivate All</action-button>
        <action-button @click="setSelectedSites('deactivate')" class="is-rounded is-danger" :disabled="sites.data.length === 0" left-icon="stop">Deactivate Selected {{ Naming.Sites }}</action-button>
      </div>
    </div>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Name</th>
          <th>{{ Naming.Zones }}</th>
          <th>{{ Naming.Assets }}</th>
          <th>{{ Naming.Jobs }}</th>
          <th class="has-text-right">Current Risk</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="site in sites.data" :key="site.id">
          <td class="is-flex is-align-items-center">
            <span class="is-flex is-align-items-center" v-if="$root.hasAbility('delete-sites', 'Billow\\Models\\Site')">
              <checkbox-input
                  v-if="filters.activeStatus === 'active'"
                  :value="siteSelection(site.id, sitesToDeactivate)"
                  @input="toggleSite(site.id, sitesToDeactivate)"
                  classes="is-circle is-danger"
                  :label="false"/>
              <checkbox-input
                  v-if="filters.activeStatus === 'deactivated'"
                  :value="siteSelection(site.id, sitesToActivate)"
                  @input="toggleSite(site.id, sitesToActivate)"
                  classes="is-circle is-success"
                  :label="false"/>
            </span>
            <link-site-manager  :class="{ 'has-text-grey': site.deactivated_at }" :site="site"/><span v-if="site.deactivated_at" class="tag is-danger ml-1">Deactivated</span>
          </td>
          <td>{{ site.zones_count }}</td>
          <td>{{ site.assets_count }}</td>
          <td>{{ site.jobs_count }}</td>
          <td class="has-text-right">
            <span v-if="site.risk" :class="`risk ${site.risk.level.toLowerCase()}`">{{ site.risk.level }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="columns">
      <div class="column">
        <pager :pageable="sites" @nav="goToPage" :context="Naming.Site.toLowerCase()"/>
      </div>
      <div class="column is-narrow">
        <router-link 
          :to="{
            name: 'client-deleted-sites',
            params: {
              client: client.id
            }
          }"
          class="is-rounded button is-small">
            <icon icon="trash"/>
            <span>Show Deleted {{ Naming.Sites }}</span>
          </router-link>
      </div>
    </div>
  </div>
</loader>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import { mixins, utilities } from '@/mixins/js-helpers'

export default {

  mixins: [mixins.filterBy],

  name: 'client-sites',

  data: () => ({
    loading: true,
    namespace: 'site',
    path: '',
    filters: {
      search: '',
      activeStatus: ''
    },
  }),

  async created() {
    await this.loadSites()
    this.loading = false
  },

  methods: {
    goToPage(path) {
      this.$router.push({
        path: path,
        query: this.filters
      })
      this.$scrollToTop()
    },
    loadSites() {
      return this.$store.dispatch('site/loadSitesByClient', {
        path: '/api' + this.$route.fullPath,
        params: this.$route.query
      })
    },
    filterBy(key, value = '') {
      this.filters[key] = value
      this.runFilters()
    },
    runFilters() {
      this.$router.push({
        name: this.$route.name,
        query: this.filters
      })
    },
    searchSites() {
      this.$store.dispatch(
        'site/loadSitesByClient',
        this.path + utilities.cleanQuery(this.filters)
      )
      this.$router.push({
        name: this.$options.name,
        query: this.filters
      })
    },
    toggleSite(siteId, siteList) {
      const index = siteList.indexOf(siteId);
      if (index === -1) {
        siteList.push(siteId);
      } else {
        siteList.splice(index, 1);
      }
    },
    siteSelection(siteId, siteList) {
      return siteList.includes(siteId)
    },
    async setAllSites(status) {
      this.loading = true
      try {
        if (status === 'deactivate') {
          const { title, message, confirmText } = this.$lang.site.confirmMassDeactivation;
          const convertedTitle = await this.Convert(title);
          const convertedMessage = await this.Convert(message);
          const convertedConfirmText = await this.Convert(confirmText);

          if (await this.$confirm({
            title: convertedTitle,
            message: convertedMessage,
            confirmText: convertedConfirmText,
            confirmClass: 'is-danger'
          })) {
            const payload = {
              client_id: this.$route.params.client,
              active_status: 'deactivate',
              deactivate_all: true
            }
            const response = await this.$store.dispatch('site/setClientSelectedSitesActiveStatus', payload)
            if (response.status === 202) {
              this.$toast.success('Success', `${this.Convert(response.data.message)}`)
            } else {
              this.$toast.success('Success', `All ${this.Naming.Sites} with no open ${this.Naming.Jobs} Deactivated`)
            }
          }
        } else if (status === 'activate') {
          const payload = {
            client_id: this.$route.params.client,
            active_status: 'activate ',
            activate_all: true
          }
          const response = await this.$store.dispatch('site/setClientSelectedSitesActiveStatus', payload)
          if (response.status === 202) {
            this.$toast.success('Success', `${this.Convert(response.data.message)}`)
          } else {
            this.$toast.success('Success', `All ${this.Naming.Sites} Activated`)
          }
        }
      } catch (error) {
        this.$whoops()
      } finally {
        await this.loadSites()
        this.loading = false
      }
    },
    async setSelectedSites(status) {
      this.loading = true
      try {
        if (status === 'deactivate') {
          const { title, message, confirmText } = this.$lang.site.confirmMassDeactivation;
          const convertedTitle = await this.Convert(title);
          const convertedMessage = await this.Convert(message);
          const convertedConfirmText = await this.Convert(confirmText);

          if (await this.$confirm({
            title: convertedTitle,
            message: convertedMessage,
            confirmText: convertedConfirmText,
            confirmClass: 'is-danger'
          })) {
            const payload = {
              client_id: this.$route.params.client,
              active_status: 'deactivate',
              site_ids: this.sitesToDeactivate
            }
            const response = await this.$store.dispatch('site/setClientSelectedSitesActiveStatus', payload)
            let message = response.data.skipped
                ? `${response.data.deactivated} ${this.Naming.Sites} Deactivated and ${response.data.skipped} ${this.Naming.Sites} have open ${this.Naming.Jobs}`
                : `${response.data.deactivated} ${this.Naming.Sites} Deactivated`
            if (response.status === 202) {
              message = this.$toast.success(`${this.Convert(response.data.message)}`)
            }
            this.$toast.success('Success', message)
          }
        } else if (status === 'activate') {
          const payload = {
            client_id: this.$route.params.client,
            active_status: 'activate',
            site_ids: this.sitesToActivate
          }
          const response = await this.$store.dispatch('site/setClientSelectedSitesActiveStatus', payload)
          if (response.status === 202) {
            this.$toast.success('Success', `${this.Convert(response.data.message)}`)
          } else {
            this.$toast.success('Success', `${response.data.activated} ${this.Naming.Sites} Activated`)
          }
        }
      } catch (error) {
          this.$whoops()
      } finally {
        await this.loadSites()
        this.loading = false
      }
    }
  },

  computed: {
    ...mapGetters('client', [
      'client'
    ]),
    ...mapState('site', ['sitesToActivate', 'sitesToDeactivate']),
    ...mapGetters('site', [
      'sites'
    ]),
  },

  watch: {
    '$route': 'loadSites'
  }
}
</script>
